module.exports = __webpack_public_path__ + "media/icons/opony-caloroczne-green-c805a11d.png";